import axios, { AxiosRequestConfig } from 'axios'
import { Message, Loading } from 'element-ui'
import badjs from '@/badjs'
import { axiosDefaultMessage } from '@/constant'
import {removeToken,removeUserToken} from "./common"
const $axios = axios.create({
    timeout: 60000,
})

// 添加响应拦截器，
$axios.interceptors.response.use(
    res => {
        const url = res.config.url

        const data = res.data || {}
        // 请求结果信息提示
        if(res.data.code===302&&res.headers['login-redirect']){
            removeToken()
            removeUserToken()
            window.location.href=res.headers['login-redirect']
        }
        if (url && axiosDefaultMessage[url]) {
            if (data.code !== 0) {
                if (axiosDefaultMessage[url].fail) {
                    Message({
                        type: 'error',
                        message: `${data.desc ? data.desc : axiosDefaultMessage[url].fail}`,
                        duration: 2500,
                    })
                }
            } else {
                if (axiosDefaultMessage[url].success) {
                    Message({
                        type: 'success',
                        message: `${axiosDefaultMessage[url].success}`,
                        duration: 2500,
                    })
                }
            }
        }

        return data
    },
    error => {
        Message({
            type: 'error',
            message: `网络错误`,
            duration: 2500,
        })

        try {
            const url = error.response.config.url
            const traceid = error.response.headers.traceid
            if (badjs) {
                badjs.report({
                    target: url,
                    msg: `traceid: ${traceid} | error: ${error}`,
                })
            }
            console.log(error)
        } catch (error) {
            console.log(error)
        }
    }
)

// 请求拦截器，添加公共参数，userID,从store里面读取
$axios.interceptors.request.use((config: AxiosRequestConfig) => {
    // const commonPramas = {
    //   userId: store.state.userId
    // };
    // if (config.method === "get") {
    //   const params = Object.assign(commonPramas, config.params);
    //   config.params = params;
    // }
    // if (config.method === "post") {
    //   const mergedData = Object.assign(commonPramas, config.data);
    //   config.data = mergedData;
    // }
    return config
})
export default $axios
